module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "content content-padding"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Lista de Slides")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.slides), function(slide) {
    return _c('level-slide', {
      attrs: {
        "slide": slide,
        "slideTotal": _vm.slides.length,
        "parent": _vm.parent,
        "menu": _vm.menu
      }
    })
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openSlideEditModal
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Criar")])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32d75412!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slide/SlideList.vue
// module id = 309
// module chunks = 1